<div class="main-page-section default_font pt-3 pt-md-4 px-3 px-md-4 px-lg-5 d-flex flex-column">
    <div class="flex-fill">
        <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
            <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev"><a routerLink="/list-food-menu/{{foodCourtVendorId}}">View Menu Items</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev">Menu Details</span>
        </div>

        <div class="align-items-center justify-content-between mb-3 mb-md-4">
            <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
                <h2 class="font-weight-bold mb-3 mb-md-4">Menu Item Details</h2>
            </div>
        </div>

        <!-- <div class="align-items-center justify-content-between mb-3 mb-md-4">
            <h6 class="font-weight-bold mb-3 mb-md-4">Media</h6>
            <div class="coupon_image">
                <img [src]="menuDetails?.data.foodImagePath" [alt]="menulogo" [title]="menulogo">
            </div>
        </div> -->

        <div class="row" *ngIf="menuDetails?.data.foodImagePath!=null">
            <div class="col-12 col-md-6 col-lg-4 col-xl-3">
                <div class="image_card">
                    <img [src]="menuDetails?.data.foodImagePath" [alt]="menulogo" [title]="menulogo">
                </div>
            </div>
        </div>
        <div class="row" *ngIf="menuDetails?.data.foodImagePath==null">
            <div class="col-12 col-md-6 col-lg-4 col-xl-3">
                <div class="image_card">
                    No Image Found
                </div>
            </div>
        </div>

        <hr>
        <h6 class="font-weight-light h5 mb-3 mb-md-4">Details</h6>
        <div class="row row-gap-4 mb-4 mb-md-5">
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium ">Name</small>
                <span class="font-weight-medium text-gray-dark">{{menuDetails?.data.foodName}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Type</small>
                <span class="font-weight-medium text-gray-dark">{{menuDetails?.data.foodType}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Cuisine</small>
                <span class="font-weight-medium text-gray-dark">{{menuDetails?.data.foodCuisine}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Price</small>
                <span class="font-weight-medium text-gray-dark">₹{{menuDetails?.data.foodPrice}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Availability</small>
                <span class="font-weight-medium text-gray-dark"
                    *ngIf="menuDetails?.data.isAvailable==true">Available</span>
                <span class="font-weight-medium text-gray-dark" *ngIf="menuDetails?.data.isAvailable==false">Not
                    Available</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Rating</small>
                <!-- <span class="font-weight-medium text-gray-dark">{{menuDetails?.data.rating}}</span> -->
                <div *ngIf="menuDetails?.data.rating>0" class="d-flex rating_wrap column-gap-1">
                    <svg-icon src="./assets/images/icons/star.svg" class="text-warning" [svgStyle]="{ 'width.px':14, 'height.px':14 }" *ngFor="let rating of ratingArray"></svg-icon>
                    <svg-icon src="./assets/images/icons/star.svg" class="text-light" [svgStyle]="{ 'width.px':14, 'height.px':14 }" *ngFor="let ratingoff of ratingArrayOff"></svg-icon>
                </div>
                <div *ngIf="menuDetails?.data.rating==0">
                    <span class="font-weight-medium text-gray-dark">No Rating Found</span>
                </div>
            </div>
        </div>
        <hr>
        <h6 class="font-weight-light h5 mb-3 mb-md-4">Description</h6>
        <div class="row row-gap-4 mb-4 mb-md-5">
            <div class="col-12 d-flex flex-column row-gap-2">
                <!-- <small class="font-weight-light text-gray-medium ">From</small> -->
                <span class="font-weight-medium text-gray-dark">{{menuDetails?.data.foodDescription}}</span>
            </div>
        </div>
    </div>
    <div
        class="details_footer shadow-lg py-3 py-md-4 d-flex align-items-center justify-content-end column-gap-3 mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mt-4 mt-md-5">
        <button class="btn btn-clear text-danger" (click)="openModal(menuId)" *ngIf="foodvendorRemove">Delete</button>
        <button class="btn btn-primary" (click)="goToEditPage(menuId)" *ngIf="foodvendorEdit">Edit Details</button>
    </div>
</div>